import React from 'react';

import classes from './AssignmentProblemCard.module.css';

const AssignmentProblemCard = (props) => {

    return (
        <div className={classes.AssignmentProblemCard}>
            <p className={[classes.ProblemLevel, classes[props.data.level]].join(' ')}>{props.data.level}</p>
            <div className={classes.CardDetails}>
                <p className={classes.ProblemName}>{props.data.name}</p>
                <p className={classes.ProblemScore}>
                    {props.data.score} <br />
                    <span>Max Score</span>
                </p>
            </div>
        </div>
    );
}

export default AssignmentProblemCard;